// features/ia/api/ia.api.js
import { api } from '../../../api/client';

export const aiAssistantApi = {
  /**
   * Envía una pregunta al asistente.
   * Retorna un Response crudo para que el caller lo lea como stream (SSE/text).
   * @param {string} question
   * @returns {Promise<Response>}
   */
  chat: async (question) => {
    const BASE_URL = (process.env.REACT_APP_API_URL || '') + '/api';
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${BASE_URL}/ai/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ question }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.detail || err?.message || 'Error en el asistente IA');
    }
    return res; // Response crudo para streaming
  },

  /** Dispara la ingesta/indexación de datos */
  triggerIngest: () =>
    api.post('/ai/ingest'),

  /** Obtiene la configuración actual del asistente */
  getConfig: () =>
    api.get('/ai/config'),

  /**
   * Actualiza la configuración del asistente
   * @param {{ system_prompt: string, behavior_rules: string[], enabled_sources: string[] }} config
   */
  updateConfig: (config) =>
    api.put('/ai/config', config),

  getDatamartRules: () =>
    api.get('/datamart/ai/queries'),
};
